import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const CompanyProfileBuyerFormStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */
  .main-content {
    .purchasing {
      .form-actions-add {
        margin-top: 0;
        margin-bottom: 20px;
        padding-right: 0;
      }
    }
  }

  .table-exchange-rate {
    min-width: 1200px;

    .tbody {
      max-height: 320px;
    }
  }

  .table-purchasing {
    min-width: 920px;

    .tbody {
      max-height: 320px;
    }
  }

  .exchange {
    .form-group {
      .label {
        min-width: 150px;
        margin-right: 60px;
      }
    }

    .form-group-control {
      /* max-width: 152px; */
    }

    .form-group-inner-wrapper {
      /* justify-content: end; */
    }

    .inline:last-child {
      margin-left: 18px;
    }
  }

  /* Modal */
  .purchasing-rate-modal {
    .tbody {
      max-height: 320px;
    }
  }

  .exchange-rate-modal {
    .tbody {
      max-height: 320px;
    }

    .select-control {
      min-width: max-content;
      background-color: ${VARIABLES.COLORS.WHITE};
    }
  }
  /* Media queries
  ------------------------------- */
`
// Supplier //
export const CompanyProfileSupplierFormStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */
  .attached-file-list {
    /* margin-top: 10px; */
    a {
      &.file-link {
        max-width: 330px;
        padding-right: 17px;
        position: relative;
        .file-name {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .input-upload-control {
    .section {
      width: 125px;
    }
  }

  .form-group > label {
    flex: 0 0 165px;
  }

  .form-group {
    .select-currency {
      max-width: 90px;
      min-width: 90px;
      margin-left: 10px;
    }

    .date-picker-wrapper {
      max-width: 500px;
      min-width: 250px;
      width: inherit;
    }

    .file-link {
      cursor: pointer;
      &.is-disabled {
        pointer-events: none;
      }
    }

    .form-group-inner-wrapper {
      flex-wrap: wrap;
    }
  }

  .service-btn {
    min-width: 320px;
  }

  .update-comprehensive {
    max-width: 100%;
    flex: 0 0 100%;

    .form-control-wrapper {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
    }

    .form-control-row {
      row-gap: 10px;
      display: flex;
      flex-direction: column;
      margin-bottom: 1rem;
    }

    .data {
      color: #4b4acb;
      flex-basis: 400px;
    }

    .form-control {
      display: flex;
      column-gap: 20px;
      flex-wrap: wrap;
    }

    .button {
      margin-left: 0 !important;
    }
  }

  .btn-comprehensive-score {
    width: 145px;
    padding: 0 1rem;
  }

  .textarea {
    max-width: 500px;
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    .form-group {
      .input-control {
        max-width: 500px;
      }
    }
  }

  @media all and (max-width: 1440.98px) {
  }

  @media all and (max-width: 1366.98px) {
    /* .form-group {
      .select-currency {
        max-width: 80px;
        min-width: 80px;
        margin-left: 10px;
      }

      .date-picker-wrapper {
        max-width: 450px;
        min-width: 230px;
      }
    } */
  }

  @media all and (max-width: 1280.98px) {
    .form-group {
      max-width: none;

      /* .select-currency {
        max-width: 75px;
        min-width: 75px;
        margin-left: 8px;
      }

      .date-picker-wrapper {
        max-width: 420px;
        min-width: 210px;
      } */
    }

    .btn-comprehensive-score {
      width: 100px;
    }
  }

  @media all and (max-width: 1024.98px) {
    /* .form-group {
      .select-currency {
        max-width: 70px;
        min-width: 70px;
        margin-left: 5px;
      }

      .date-picker-wrapper {
        max-width: 350px;
        min-width: 180px;
      }
    } */
  }
  @media all and (min-width: 1024.98px) {
    .form-wrapper:has(.regis_capital > input:focus) {
      .form-group {
        .registered-address,
        .country,
        .contact-address,
        .phone,
        .fax,
        .email,
        .website,
        .tooltip-upload,
        .business-type,
        .service-category,
        .update-online {
          color: #1f2937;
        }
      }
      .form-group-header {
        color: #1f2937;
      }
      .form-group-inner-wrapper.checkbox > .checkbox .fake-label {
        color: #1f2937;
      }
      .service-category-table {
        .business-group,
        .service-product {
          color: #06304f;
        }
      }
    }
  }
`
